// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__FedraSerifDisplayLight_75aa9a', '__FedraSerifDisplayLight_Fallback_75aa9a'"},"className":"__className_75aa9a","variable":"__variable_75aa9a"};